import { isCustomObject } from 'automation-ui-references/object-types/objectTypeUtils';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { CONTACT_ID, COMPANY_ID, DEAL_ID, TICKET_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { WEBHOOK_TRIGGERS_ACCESS } from 'automation-ui-enrollment/constants/Scopes';
export const WEBHOOK_TRIGGERS_V2_OBJECT_TYPES = new Set([CONTACT_ID, COMPANY_ID, DEAL_ID, TICKET_ID]);
export const areWebhookTriggersAllowedForObjectType = objectTypeId => WEBHOOK_TRIGGERS_V2_OBJECT_TYPES.has(objectTypeId) || isCustomObject(objectTypeId);
const useHasWebhookTriggersAccess = objectTypeId => {
  const hasWebhookTriggersScope = useHasScope(WEBHOOK_TRIGGERS_ACCESS);
  return {
    hasWebhookTriggersScope,
    webhookTriggersAllowedForObjectType: areWebhookTriggersAllowedForObjectType(objectTypeId)
  };
};
export default useHasWebhookTriggersAccess;